module.exports = __webpack_public_path__ + "img/category_hiking.ac68aff.png";